export default function FounderSection() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="founder" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="text-xs font-medium tracking-widest uppercase text-[#3b82f6] font-['Inter']">The Founder</span>
          <h2 className="font-['DM_Serif_Display'] text-4xl md:text-5xl text-[#0f172a] mt-3 mb-6 leading-tight">
            Partner With<br /><em>Cash Learn</em>
          </h2>
          <blockquote className="border-l-2 border-[#3b82f6] pl-5 mb-6">
            <p className="font-['Playfair_Display'] text-lg italic text-[#1e3a5f] leading-relaxed">
              &ldquo;Every student deserves to graduate with the financial infrastructure knowledge to navigate the real economic systems they&apos;ll face — not just the theory, but the practical architecture of money, credit, and wealth.&rdquo;
            </p>
          </blockquote>
          <p className="text-[#475569] text-sm leading-relaxed font-['Inter'] mb-4">
            Cash Learn was founded on the belief that economic preparedness is a fundamental educational right — not a privilege. The initiative emerged from years of observing the downstream consequences of financial illiteracy across workforce, housing, and wealth-building outcomes for American youth.
          </p>
          <p className="text-[#475569] text-sm leading-relaxed font-['Inter'] mb-8">
            Cash Learn is actively developing institutional partnerships, research collaborations, and pilot implementations. We welcome school districts, nonprofits, policy organizations, and workforce development programs to engage during this foundational phase.
          </p>
          <div className="flex flex-wrap gap-3 mb-8">
            {["Framework Development", "Pilot Structuring", "Policy Integration", "Research Collaboration"].map((badge, i) => (
              <span key={i} className="px-3 py-1.5 bg-[#eff6ff] border border-[#dbeafe] text-[#1d4ed8] text-xs rounded-full font-['Inter']">
                {badge}
              </span>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {[
              { icon: "ri-building-4-line", title: "School Districts", desc: "Curriculum integration and pilot program partnerships" },
              { icon: "ri-heart-line", title: "Nonprofits", desc: "Community financial education program development" },
              { icon: "ri-government-line", title: "Policy Organizations", desc: "State mandate alignment and advocacy support" },
              { icon: "ri-microscope-line", title: "Research Institutions", desc: "Longitudinal outcome studies and data collaboration" },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 p-4 bg-[#f8faff] border border-[#dbeafe] rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#eff6ff] flex-shrink-0">
                  <i className={`${item.icon} text-[#1d4ed8] text-sm`} />
                </div>
                <div>
                  <div className="text-xs font-semibold text-[#0f172a] font-['Inter']">{item.title}</div>
                  <div className="text-xs text-[#94a3b8] mt-0.5 font-['Inter']">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => handleScroll("contact")}
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#1d4ed8] hover:bg-[#1e40af] text-white rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            Request Institutional Briefing <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
